import { transformMarkets } from '../../services/UserGroup.js';
import { APP_CONFIG, getHeaders } from '../constants/global-variables.js';

export async function getMatch(matchId) {
    const url = `${APP_CONFIG.URL.apiBasePath}ajax/prematchgame/${matchId}`;

    try {
        const res = await axios.get(url, getHeaders());
        const dataTransformed = transformMarkets(res.data);
        return dataTransformed;
    } catch (err) {
        //console.log('Error getting documents', err);
    }
}

